/**
 * Centralized service endpoint configuration.
 *
 * Every external URL the app talks to should be imported from here.
 * This makes it easy to audit, search, and swap endpoints per environment.
 */

// ── Core backends ────────────────────────────────────────────────
export const KC_BASE = 'https://kc.retailpulse.ai';
export const KC_API = `${KC_BASE}/api`;

export const DARKARTS_BASE = 'https://darkarts.retailpulse.ai';
export const DARKARTS_API = `${DARKARTS_BASE}/api`;

export const ONDC_BASE = 'https://ondc.retailpulse.ai';

// ── diagon-alley seller BE (kb-experiment POC + kirana-bazar balance) ──
// One host for every diagon path. Prod is ONDC_BASE; for local BE dev, temporarily point
// this at your tunnel (e.g. an ngrok :81) — do NOT commit that.
export const DIAGON_BASE = ONDC_BASE;
export const KB_EXPERIMENT_BASE = `${DIAGON_BASE}/kb-experiment`;
// Seller-header balance pill: POST { data:{ uid, appVersion, deviceId, seller } }
// → { status, data:{ cashback, wallet, total } }.
export const KB_BALANCE_URL = `${DIAGON_BASE}/kirana_bazar/balance`;
// Live webinar watch milestone: POST { user_id, milestone: '3min' | '5min' } → { status: 'OK' }.
export const LIVE_WEBINAR_WATCH_MILESTONE_URL = `${DIAGON_BASE}/kirana_bazar/live_webinar/watch_milestone`;
// Kirana Mall — the multi-seller STOREFRONT. Same host, same envelope, same three
// paths (seller_screen / plp / cart_refresh). Seller is fixed server-side to
// kirana_mall and is never sent, so there is no seller param anywhere below.
export const KIRANA_MALL_BASE = `https://ondc.retailpulse.ai/kirana_mall`;

// ── Creator dashboard cloud function (hogwarts) ──────────────────
// Firebase onCall; routes by `type` (get_vip_users, post_creation_screen, …).
export const CREATOR_DASHBOARD_FN =
	'https://asia-south1-op-d2r.cloudfunctions.net/creatorDashboard';

export const BRAND_PULSE_BASE = 'https://brandpulse.retailpulse.ai';

// Grimwald — loyalty / cashback service.
export const GRIMWALD_BASE = 'https://grimwald.retailpulse.ai';

// ── MQTT (chat) ──────────────────────────────────────────────────
export const MQTT_HOST = 'mqtt.retailpulse.ai';
export const MQTT_PORT = 8084;
export const MQTT_CONNECT_URL = `wss://${MQTT_HOST}:${MQTT_PORT}/mqtt`;

// ── Self-referential (webviews app itself) ───────────────────────
export const WEBVIEWS_BASE = 'https://webviews.retailpulse.ai';
